// Module
var code = `<div class="absolute-fill" id="spatialMap">
    <div id="mapid"></div>
</div>
`;
// Exports
export default code;